export enum PaymentState {
  NO_DATA,
  AMOUNTS_MISMATCH,
  PARTIAL_CAPTURE,
  PARTIAL_AUTHORIZED,
  FULLY_SETTLED,
  IS_PENDING,
}
